<div class="form-container">
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;">
          {{ isEditMode ? 'Edit Candidate' : 'Add New Candidate' }}
        </div>
      </ion-col>
      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <div class="form-scroll-container" style="padding: 0rem !important;">
      <form [formGroup]="candidateForm">
        <ion-grid>

          <ion-row>
            <ion-col size="6">
              <label class="formLabelRegularfs16 mb-5">Name<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="name" placeholder="Enter candidate name" />
                <mat-error *ngIf="candidateForm.get('name')?.hasError('required')">Name is required</mat-error>
                <mat-error *ngIf="candidateForm.get('name')?.hasError('maxlength')">Maximum 100 characters
                  allowed</mat-error>
              </mat-form-field>
            </ion-col>

            <ion-col size="6">
              <label class="formLabelRegularfs16 mb-5">Phone<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput type="tel" maxlength="10" pattern="[0-9]*" formControlName="phone"
                  placeholder="Enter phone number" (keypress)="onlyNumberKey($event)" />
                <mat-error *ngIf="candidateForm.get('phone')?.hasError('required')">Phone is required</mat-error>
                <mat-error *ngIf="candidateForm.get('phone')?.hasError('pattern')">Enter a valid phone
                  number</mat-error> <mat-error
                  *ngIf="candidateForm.get('phone')?.hasError('maxlength') || candidateForm.get('phone')?.hasError('minlength')">
                  Must be exactly 10 digits
                </mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Email<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput type="email" formControlName="email" placeholder="Enter email address" />
                <mat-error *ngIf="candidateForm.get('email')?.hasError('required')">Email is required</mat-error>
                <mat-error *ngIf="candidateForm.get('email')?.hasError('email')">Enter a valid email</mat-error>
                <mat-error *ngIf="candidateForm.get('email')?.hasError('maxlength')">Maximum 100 characters
                  allowed</mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Position Applied For<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select position" formControlName="positionAppliedFor">
                  <mat-option *ngFor="let position of positionsList" [value]="position.positionId">{{
                    position.positionName }}</mat-option>
                </mat-select>
                <mat-error *ngIf="candidateForm.get('positionAppliedFor')?.hasError('required')">Position is
                  required</mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Year of Experience<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput type="number" min="0" placeholder="Enter years of experience"
                  formControlName="experienceYears" />
                <mat-error *ngIf="candidateForm.get('experienceYears')?.hasError('required')">Experience is
                  required</mat-error>
                <mat-error *ngIf="candidateForm.get('experienceYears')?.hasError('min')">Value cannot be
                  negative</mat-error>
                <mat-error *ngIf="candidateForm.get('experienceYears')?.hasError('max')">
                  Maximum value is 99
                </mat-error>
              </mat-form-field>
            </ion-col>

            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Date of Birth</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput [matDatepicker]="dobPicker" placeholder="Select DOB" readonly formControlName="dob"
                  [max]="maxDobDate" (focus)="dobPicker.open()" (click)="dobPicker.open()" />
                <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
                <mat-datepicker #dobPicker></mat-datepicker>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Current CTC</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="currentCtc" placeholder="e.g., 3 LPA - 5 LPA" />
                <mat-error *ngIf="candidateForm.get('currentCtc')?.hasError('maxlength')">
                  Max 20 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Expected Salary <span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput placeholder="e.g., 3 LPA - 5 LPA" formControlName="expectedSalary" />
                <mat-error *ngIf="candidateForm.get('expectedSalary')?.hasError('required')">Expected salary is
                  required</mat-error>
                <mat-error *ngIf="candidateForm.get('expectedSalary')?.hasError('maxlength')">
                  Max 20 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Current Location<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="currentLocation" placeholder="Enter current location" />
                <mat-error *ngIf="candidateForm.get('currentLocation')?.hasError('required')">Current Location is required</mat-error>

                <mat-error *ngIf="candidateForm.get('currentLocation')?.hasError('maxlength')">
                  Max 100 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Preferred Location<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput formControlName="preferredLocation" placeholder="Enter preferred location" />
                
                <mat-error *ngIf="candidateForm.get('preferredLocation')?.hasError('required')">Preferred Location is required</mat-error>
                <mat-error *ngIf="candidateForm.get('preferredLocation')?.hasError('maxlength')">
                  Max 100 characters allowed
                </mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Skills<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput placeholder="e.g., Angular, TypeScript" formControlName="skills" />
                <mat-error *ngIf="candidateForm.get('skills')?.hasError('required')">Skills are required</mat-error>
                <mat-error *ngIf="candidateForm.get('skills')?.hasError('maxlength')">Max 200 characters
                  allowed</mat-error>
              </mat-form-field>
            </ion-col>

            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Top 2 Qualifications<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput placeholder="e.g., B.Tech, M.Sc" formControlName="education" />
                <mat-error *ngIf="candidateForm.get('education')?.hasError('required')">Education is
                  required</mat-error> <mat-error *ngIf="candidateForm.get('education')?.hasError('maxlength')">Max 200
                  characters allowed</mat-error>
              </mat-form-field>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Application Date</label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput readonly [value]="candidateForm.get('applicationDate')?.value | date: 'dd/MM/yyyy'"
                  placeholder="Select date" />
              </mat-form-field>
            </ion-col>


            <!-- <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Source<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select source" formControlName="source">
                  <mat-option *ngFor="let src of sources" [value]="src">{{ src }}</mat-option>
                </mat-select>
                <mat-error *ngIf="candidateForm.get('source')?.hasError('required')">Source is required</mat-error>
              </mat-form-field>
            </ion-col> -->
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Source<span class="red-cl"> *</span></label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <mat-select placeholder="Select source" formControlName="source">
                  <mat-option *ngFor="let src of sources" [value]="src.jobPlatformName">
                    {{ src.jobPlatformName }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="candidateForm.get('source')?.hasError('required')">
                  Source is required
                </mat-error>
              </mat-form-field>
            </ion-col>

          </ion-row>
          <ion-row>
            <ion-col size="12" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Job Description</label>
              <mat-form-field class="w-100  mat-input-style">
                <textarea matInput formControlName="jobDescription" readonly rows="3"
                  placeholder="Job description will appear here..."></textarea>
                <!-- <mat-error *ngIf="candidateForm.get('jobDescription')?.hasError('maxlength')">
                  Max 2 characters allowed
                </mat-error> -->
              </mat-form-field>
            </ion-col>

          </ion-row>

          <ion-row>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">
                Notice Period (in days)<span class="red-cl"> *</span>
              </label>
              <mat-form-field class="w-100 mat-height40 mat-input-style">
                <input matInput type="number" min="0" placeholder="Enter notice period" formControlName="noticePeriod"
                  min="0" max="999" />
                <mat-error *ngIf="candidateForm.get('noticePeriod')?.hasError('required')">
                  Notice period is required
                </mat-error>
                <mat-error *ngIf="candidateForm.get('noticePeriod')?.hasError('min')">
                  Notice period cannot be negative
                </mat-error><mat-error *ngIf="candidateForm.get('noticePeriod')?.hasError('max')">
                  Cannot be more than 999
                </mat-error>
              </mat-form-field>
            </ion-col>
            <ion-col size="6" class="mt-10">
              <label class="formLabelRegularfs16 mb-5">Resume<span class="red-cl"> *</span></label>
              <div class="form-field-upload">
                <button type="button" class="upload-btn" (click)="resumeInput.click()">
                  <ion-icon name="cloud-upload-outline"></ion-icon> Upload Resume
                </button>

                <div class="file-info" *ngIf="selectedResumeName">
                  <span class="file-name">{{ selectedResumeName }}</span>
                  <ion-icon name="close-circle-outline" class="clear-icon" (click)="clearResume()"
                    title="Clear Resume"></ion-icon>
                </div>

                <input type="file" id="resumeUpload" #resumeInput (change)="onResumeUpload($event)" hidden
                  accept=".pdf,.doc,.docx" />
              </div>
            </ion-col>
          </ion-row> 
          <ion-row>
            <ion-col size="12" class="text-right mt-10">
              <span *ngIf="errorMessage" class="error-text">
                {{ errorMessage }}
              </span>
              <button class="back_btn fs-14" (click)="onCancel()">Cancel</button>
              <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName"
                [disabled]="isSubmitting" (click)="onSubmit()">
                {{ isEditMode ? 'Update Candidate' : 'Apply' }}
              </button>
            </ion-col>
          </ion-row>

        </ion-grid>
      </form>
    </div>
  </div>
</div>